var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer fixed-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-between"},[_c('div',{staticClass:"col-4"},[_vm._v(" © "),_c('ocom'),_vm._v(" "+_vm._s(_vm.year)+" ")],1),_c('div',{staticClass:"col-4 text-right"},[_vm._v("Version "+_vm._s(_vm.version))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }